import React from "react";
import { weeks } from "../../../../utils/constanst.js";
import { readBranches } from "../../../../services/branch.service.ts";
import { useState, useEffect } from "react";
import BranchAutocomplete from "../../../common/BranchAutocomplete.tsx";
import WeekSelect from "./WeekSelect.tsx";
import "../../../common/chstFilterControls.css";

interface ConfigHorarioSemanalFiltersProps {
  formik: any;
  branchId: number;
  initialBranchId: number;
  onBranchChange: (branchId: number) => void;
  canChangeBranch: boolean;
  onFilterChange: () => void;
  branchName?: string;
  onExportClick: () => void;
  onSaveClick: () => void;
  onFillWeekClick: () => void;
  onSyncWithScheduleClick: () => void;
  saving?: boolean;
  hasUnsavedChanges?: boolean;
  onRefreshClick: () => void;
  onNotesClick?: () => void;
  onDownloadTablePdf?: () => void;
  exportingTablePdf?: boolean;
}

const ConfigHorarioSemanalFilters: React.FC<ConfigHorarioSemanalFiltersProps> = ({
  formik,
  branchId,
  initialBranchId,
  onBranchChange,
  canChangeBranch,
  onFilterChange,
  branchName,
  onExportClick,
  onSaveClick,
  onFillWeekClick,
  onSyncWithScheduleClick,
  saving = false,
  hasUnsavedChanges = false,
  onRefreshClick,
  onNotesClick,
  onDownloadTablePdf,
  exportingTablePdf = false,
}) => {
  const [branches, setBranches] = useState<any[]>([]);
  const [loadingBranches, setLoadingBranches] = useState(false);

  useEffect(() => {
    if (canChangeBranch) {
      const fetchBranches = async () => {
        try {
          setLoadingBranches(true);
          const branchesData = await readBranches();
          setBranches(branchesData);
        } catch (error) {
          console.error("Error loading branches:", error);
        } finally {
          setLoadingBranches(false);
        }
      };
      fetchBranches();
    }
  }, [canChangeBranch]);

  return (
    <div className="chst-filters-bar">
      <div className="chst-filters-bar__row">
        <div className="chst-filters-bar__fields">
          <div className="chst-filters-bar__field">
            {canChangeBranch ? (
              <BranchAutocomplete
                branches={branches}
                value={branchId}
                onChange={onBranchChange}
                disabled={loadingBranches}
                placeholder="Seleccionar sucursal..."
                compact
                showClear={false}
              />
            ) : (
              <div className="chst-filter-static">
                <span className="chst-filter-icon chst-filter-icon--branch" aria-hidden="true">
                  <i className="fa fa-building" />
                </span>
                <span className="chst-filter-body">
                  <span className="chst-filter-label">Sucursal</span>
                  <span className="chst-filter-value">
                    {branchName || "Cargando..."}
                  </span>
                </span>
              </div>
            )}
          </div>

          <div className="chst-filters-bar__field chst-filters-bar__field--week">
            <WeekSelect
              weeks={weeks}
              value={Number(formik.values.week)}
              onChange={(weekId) => formik.setFieldValue("week", weekId)}
            />
          </div>
        </div>

        <div className="chst-filters-bar__actions">
          {onNotesClick && (
            <button
              type="button"
              onClick={onNotesClick}
              title="Notas de la semana"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 14px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#854D0E",
                backgroundColor: "#FEF9C3",
                border: "1px solid #FDE047",
                borderRadius: "12px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FEF08A";
                e.currentTarget.style.borderColor = "#FACC15";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FEF9C3";
                e.currentTarget.style.borderColor = "#FDE047";
              }}
            >
              <i className="fas fa-sticky-note" style={{ fontSize: "14px" }} aria-hidden="true" />
              <span>Notas</span>
            </button>
          )}
          <button
            type="button"
            onClick={onRefreshClick}
            title="Actualizar"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "10px 14px",
              minHeight: "42px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#065F46",
              backgroundColor: "#D1FAE5",
              border: "1px solid #6EE7B7",
              borderRadius: "12px",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#A7F3D0";
              e.currentTarget.style.borderColor = "#34D399";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#D1FAE5";
              e.currentTarget.style.borderColor = "#6EE7B7";
            }}
          >
            <i className="fas fa-rotate-right" style={{ fontSize: "14px" }} aria-hidden="true" />
            <span>Actualizar</span>
          </button>
          {onDownloadTablePdf && (
            <button
              type="button"
              onClick={onDownloadTablePdf}
              disabled={exportingTablePdf}
              title="Descargar la tabla actual como PDF"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 14px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#FFFFFF",
                backgroundColor: exportingTablePdf ? "#9CA3AF" : "#DC2626",
                border: `1px solid ${exportingTablePdf ? "#6B7280" : "#B91C1C"}`,
                borderRadius: "12px",
                cursor: exportingTablePdf ? "not-allowed" : "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!exportingTablePdf) {
                  e.currentTarget.style.backgroundColor = "#B91C1C";
                  e.currentTarget.style.borderColor = "#991B1B";
                }
              }}
              onMouseLeave={(e) => {
                if (!exportingTablePdf) {
                  e.currentTarget.style.backgroundColor = "#DC2626";
                  e.currentTarget.style.borderColor = "#B91C1C";
                }
              }}
            >
              <i className={`fas ${exportingTablePdf ? "fa-spinner fa-spin" : "fa-file-pdf"}`} style={{ fontSize: "14px" }} />
              <span>{exportingTablePdf ? "Descargando..." : "Descargar"}</span>
            </button>
          )}
          {hasUnsavedChanges && (
            <button
              type="button"
              onClick={onSaveClick}
              disabled={saving}
              title="Guardar horario semanal"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 20px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#1D4ED8",
                backgroundColor: saving ? "#E0E7FF" : "#DBEAFE",
                border: "1px solid #93C5FD",
                borderRadius: "12px",
                cursor: saving ? "not-allowed" : "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#BFDBFE";
                  e.currentTarget.style.borderColor = "#60A5FA";
                }
              }}
              onMouseLeave={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#DBEAFE";
                  e.currentTarget.style.borderColor = "#93C5FD";
                }
              }}
            >
              {saving ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: "14px" }} />
                  <span>Guardando...</span>
                </>
              ) : (
                <>
                  <i className="fas fa-check" style={{ fontSize: "14px" }} />
                  <span>Guardar</span>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigHorarioSemanalFilters;
